module.exports = __webpack_public_path__ + "static/media/megaphone.5c48cd65.svg";